import React from 'react';

interface SearchSkeletonProps {
  isMobileView?: boolean;
}

export const SearchSkeleton: React.FC<SearchSkeletonProps> = ({ isMobileView = false }) => {
  return (
    <>
      {!isMobileView && <SkeletonHeader />}
      <div className="search-result-skeleton-list">
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={`skeleton-${index}`}>
            <SkeletonItem />
          </div>
        ))}
      </div>
    </>
  );
};

export const SkeletonHeader: React.FC = () => (
  <div className="results-header">
    <div className="results-info">
      <div className="skeleton-results-header"></div>
    </div>
    <div className="results-stats">
      <div className="search-result-skeleton-time"></div>
    </div>
  </div>
);

export const SkeletonItem: React.FC = () => (
  <div className="search-result-skeleton">
    <div className="search-result-skeleton-left"></div>
    <div className="search-result-skeleton-right">
      <div className="search-result-skeleton-title"></div>
      <div className="search-result-skeleton-content"></div>
    </div>
    <div className="search-result-skeleton-time"></div>
  </div>
);